import React from 'react';

import styles from './page-description.module.scss';

export const PageDescription: React.FC<{
  children?: string;
}> = ({ children }) => {
  return (
    <div className={styles.pageDescription}>
      {children ? (
        <div
          className={styles.headerMainText}
          dangerouslySetInnerHTML={{ __html: children }}
        />
      ) : null}
    </div>
  );
};